import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "title-2 m-0 mb-3" }
const _hoisted_3 = { class: "d-flex flex-column position-relative mb-5" }
const _hoisted_4 = ["src", "onClick"]
const _hoisted_5 = { class: "subcaption prestation-name text-center w-100 mt-2" }

import { ref, Ref } from "vue";

  // Utils
  import {isMobile} from '@/utils/utils.js'; 

  // Types
  import { IPicturesAccomodation, PrestationData } from "@/types/index";

  // Props
  
export default /*@__PURE__*/_defineComponent({
  __name: 'MiniaturesSection',
  props: {
    prestations: {}
  },
  setup(__props: any) {

  // Vue
  const prestationsArray = __props;

  // Template REFs
  const miniatureAccomodationContainer: Ref<HTMLElement | null> = ref(null);

  // Content
  const content = window.content

  // Data
  const isDisplayArrowsInMobile = prestationsArray.prestations.length > 2 && isMobile()
  const isDisplayArrowsInDesktop = prestationsArray.prestations.length > 5 && !isMobile()

  /**
   * Retrieves the URL of the image to be displayed from the given IPicturesAccomodation object.
   *
   * @param {IPicturesAccomodation} image - The object containing different sizes of an accommodation picture.
   * @returns {string} - The URL of the image to be displayed.
   *
   * The function prioritizes the larger image sizes, returning the first available URL in the order:
   * 1. `imgXL`
   * 2. `imgLarge`
   * 3. `img`
   *
   * If the larger sizes are not available, it defaults to the next available image.
   */
  const getImageUrl = (image: IPicturesAccomodation): string => {
    return image.imgXL || image.imgLarge || image.img;
  };

  /**
   * Scrolls the thumbnail container left or right based on the direction provided.
   *
   * @param {('left' | 'right')} direction - The direction in which to scroll the container.
   *        Use 'left' to scroll towards the left and 'right' to scroll towards the right.
   *
   * The function calculates the scroll amount based on the container's width and scrolls
   * it smoothly in the specified direction. The amount of scroll is determined by dividing
   * the container's width by 4, allowing the user to scroll a quarter of the container's
   * width per click.
   */
  const scrollThumbnail = (direction: "left" | "right"): void => {
    const container = miniatureAccomodationContainer.value;
    if (container) {
      const scrollAmount = container.offsetWidth / 4;
      const scrollDirection = direction === "left" ? -scrollAmount : scrollAmount;
      container.scrollBy({ left: scrollDirection, behavior: "smooth" });
    }
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(content).gallery_photos), 1),
    _createElementVNode("div", _hoisted_3, [
      (_unref(isDisplayArrowsInMobile) || _unref(isDisplayArrowsInDesktop))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "arrow left-arrow position-absolute rounded-circle p-1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (scrollThumbnail('left')))
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("svg", {
              width: "21",
              height: "18",
              class: "icon"
            }, [
              _createElementVNode("use", { "xlink:href": "#___icon___chevron-left-bold" })
            ], -1)
          ])))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "d-flex overflow-hidden miniaturesContainer",
        ref_key: "miniatureAccomodationContainer",
        ref: miniatureAccomodationContainer
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prestations, (prestation, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `${index}-${prestation.accomodationName}`,
            class: "d-flex align-items-center flex-column me-3 w-25"
          }, [
            _createElementVNode("img", {
              src: getImageUrl(prestation.picturesAccomodation[0]),
              alt: "Miniature of Accommodation",
              class: "prestation-image rounded",
              onClick: ($event: any) => (_ctx.$emit('navigate', prestation.accomodationName))
            }, null, 8, _hoisted_4),
            _createElementVNode("div", _hoisted_5, _toDisplayString(prestation.accomodationName), 1)
          ]))
        }), 128))
      ], 512),
      (_unref(isDisplayArrowsInMobile) || _unref(isDisplayArrowsInDesktop))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "arrow right-arrow position-absolute rounded-circle p-1",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (scrollThumbnail('right')))
          }, _cache[3] || (_cache[3] = [
            _createElementVNode("svg", {
              width: "21",
              height: "18",
              class: "icon"
            }, [
              _createElementVNode("use", { "xlink:href": "#___icon___chevron-right-bold" })
            ], -1)
          ])))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})